import $ from 'jquery'
import manager from '../manager'
import { isEditorPage } from '@/utils/page'
import floorPosition from '@/utils/floorPosition'
manager.add('floor', {
	created(showFirst,showFirstoffSet) {
        showFirstoffSet=showFirstoffSet||700
        this.isShow=false
        if(isEditorPage()){
            showFirst=true
        }
        if(showFirst){
            this.isShow=true
            $(this.dom).show()
        }else{
            let box=$(window)
            this.handleScroll=()=>{
                if(box.scrollTop()>showFirstoffSet){
                    if(this.isShow){
                        return
                    }
                    this.isShow=true
                    $(this.dom).fadeIn()
                }else{
                    if(!this.isShow){
                        return
                    }
                    this.isShow=false
                    $(this.dom).fadeOut()
                }
            }
            $(window).on("scroll",this.handleScroll)
        }
        if(isEditorPage()){
            return
        }
        try {
            var configData = JSON.parse($(this.dom).find(".configData").text())
            var styleData = JSON.parse($(this.dom).find(".styleData").text())
        } catch (err) {
            console.warn('楼层模块数据解析错误')
        }
        let position=floorPosition({configData,styleData})
        $(this.dom).css(position)
    },
    destroyed(){
        if(this.handleScroll){
            $(window).off("scroll",this.handleScroll)
        }
    }
})
